<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-investimenti page-operative-data-analysis-investimenti-list d-flex flex-column h-100">
    <div class="flex-grow-1 container-fluid d-flex flex-column h-100">
      <div class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap mb-5">
        <PageTitle class="mb-2 mb-md-0">Investimenti</PageTitle>

        <app-router-link v-if="userCanEdit" class="btn btn-primary" :to="{ name: 'operative-company.data-analysis.investimenti.add' }">
          Aggiungi investimento
        </app-router-link>
      </div>

      <div class="flex-grow-1 d-flex flex-column h-100 overflow-auto">
        <LoadingDataLoader v-if="isLoadingData"></LoadingDataLoader>
        <ErrorOnLoadingDataFeedback v-else-if="errorLoadingData"></ErrorOnLoadingDataFeedback>
        <template v-else>
          <div class="d-flex align-items-center justify-content-between">
            <ForecastListSwitcher :viewMode="viewMode" @update:viewMode="setViewMode" />

            <BFormCheckbox v-if="viewMode === 'forecast'" v-model="isSticky" class="no-select" :switch="true">
              Blocca aggregato in alto
            </BFormCheckbox>
          </div>

          <template v-if="viewMode === 'forecast' && data">
            <div class="overflow-auto report-texts-size">
              <OperativeTable dense sticky>
                <template v-for="(table, i) in aggregateTableRows">
                  <OperativeTableAggregateTable v-if="i === 0" :key="'aggregate-' + i" :sticky="isSticky">
                    <OperativeTableBodyHeader :years="aggregateTableHeadings" show-years>{{ table.name }}</OperativeTableBodyHeader>
                    <OperativeTableBodyRow :values="table.data.investimento">
                      Investimento
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.iva">
                      Iva
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.importoIvato">
                      Importo con iva
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.pagamento">
                      Pagamenti
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.debito">
                      Debito
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.ammortamenti">
                      Ammortamenti
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.immobilizzazioni">
                      Immobilizzazioni
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableBodyRow :values="table.data.maggioriAmmortamentiFiscali">
                      Maggiori ammortamenti fiscali
                      <template #cell-content="{ value }">{{ value | money }}</template>
                    </OperativeTableBodyRow>
                    <OperativeTableEmptyBodyRow v-if="i !== aggregateTableRows.length - 1" :fixedNumColumns="aggregateTableHeadings.length + 1" />
                  </OperativeTableAggregateTable>
                  <tbody v-else :key="'item-' + i">
                    <OperativeTableBodyHeader :years="aggregateTableHeadings" :show-years="openedRows[table.id]">
                      <p class="mb-0 px-1" @click="toggleRow(table.id)" style="user-select: none; cursor: pointer">
                        <i v-if="openedRows[table.id]" class="fas fa-caret-up"></i>
                        <i v-else class="fas fa-caret-down"></i>
                        {{ table.name }}
                      </p>
                    </OperativeTableBodyHeader>
                      <template v-if="openedRows[table.id]">
                        <OperativeTableBodyRow :values="table.data.investimento">
                          Investimento
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.iva">
                          IVA
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.importoIvato">
                          Importo + IVA
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.pagamento">
                          Pagamento
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.debito">
                          Debito
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.mesiAmmortamento">
                          Mesi di ammortamento
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.ammortamenti">
                          Ammortamenti
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.immobilizzazioni">
                          Immobilizzazioni
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                        <OperativeTableBodyRow :values="table.data.maggioriAmmortamentiFiscali">
                          Maggiori Ammortamenti Fiscali
                          <template #cell-content="{ value }">{{ value | money }}</template>
                        </OperativeTableBodyRow>
                      </template>
                    <OperativeTableEmptyBodyRow v-if="i !== aggregateTableRows.length - 1" :fixedNumColumns="aggregateTableHeadings.length + 1" />
                  </tbody>
                </template>
              </OperativeTable>
            </div>
          </template>
          <InvestimentiListTable v-else-if="viewMode === 'list' && results" class="report-texts-size" :investimenti="results" :edit-enabled="userIsAdmin || userIsContextCompanyConsultant || userIsContextCompanyOwner" @delete="removeInvestimento" />
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';
import loadingDataMixin from '../../../../../mixins/loadingData';
import computedFinancialDataMixin from '../../../../../mixins/computedFinancialData';
import confirmWithModalMixin from '../../../../../libs/Confirm/mixins/confirmWithModal';
import formatMoneyFilter from '../../../../../filters/formatMoney';

import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'page-operative-company-data-analysis-investimenti-list',
  mixins: [operativePageMixin, loadingDataMixin, computedFinancialDataMixin, confirmWithModalMixin],
  components: {
    BFormCheckbox,
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    ErrorOnLoadingDataFeedback: () => import('../../../../components/Operative/ErrorOnLoadingDataFeedback'),
    LoadingDataLoader: () => import('../../../../components/Operative/LoadingDataLoader'),
    OperativeTable: () => import('../../../../components/Operative/OperativeTable'),
    OperativeTableBodyHeader: () => import('../../../../components/Operative/OperativeTableBodyHeader'),
    OperativeTableBodyRow: () => import('../../../../components/Operative/OperativeTableBodyRow'),
    OperativeTableEmptyBodyRow: () => import('../../../../components/Operative/OperativeTableEmptyBodyRow'),
    OperativeTableAggregateTable: () => import('../../../../components/Operative/OperativeTable/OperativeTableAggregateTable'),
    ForecastListSwitcher: () => import('../../../../components/Operative/ForecastListSwitcher'),
    InvestimentiListTable: () => import('../../../../components/Operative/ListTable/InvestimentiListTable'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  data () {
    return {
      data: null,
      results: null,
      viewMode: 'forecast',
      isSticky: true,
      openedRows: {},
    };
  },
  computed: {
    aggregateTableHeadings () {
      if (!this.data || this.data.length < 0) {
        return [];
      }

      return this.convertToMonthsHeading(this.data[0].data);
    },
    aggregateTableRows () {
      if (!this.data || this.data.length < 0) {
        return [];
      }

      return this.data.map(d => ({
        id: d.id,
        name: d.name,
        data: this.convertToRowGroup(d.data, [
          'investimento',
          'iva',
          'importoIvato',
          'pagamento',
          'debito',
          'mesiAmmortamento',
          'ammortamenti',
          'immobilizzazioni',
          'maggioriAmmortamentiFiscali',
        ]),
      }));
    },
  },
  methods: {
    setViewMode (mode) {
      if (mode === 'forecast') {
        this.retrieveForecastData();
      } else if (mode === 'list') {
        this.retrieveListData();
      }
      this.viewMode = mode;
    },
    retrieveForecastData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getComputedInvestimenti(this.company?.id)
        .then(res => {
          this.data = res?.data?.data || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    retrieveListData () {
      if (!this.company) {
        return;
      }

      this.resetErrorOnLoadingData();
      this.setDataLoading();
      this.$api.getInvestimenti(this.company?.id)
        .then(res => {
          this.results = res?.data?.investimenti || [];
        })
        .catch(this.setErrorOnLoadingData)
        .finally(this.setDataLoaded)
      ;
    },
    removeInvestimento (id) {
      this.confirm('Cancellare l\'investimento selezionato? L\'operazione è irreversibile', 'Ok', 'Annulla')
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.$api.deleteInvestimento(this.company.id, id).then(() => this.retrieveListData()).catch(this.$log.error);
        })
      ;
    },
    toggleRow (id) {
      if (undefined === this.openedRows[id]) {
        this.$set(this.openedRows, id, true);

        return;
      }

      this.$set(this.openedRows, id, !this.openedRows[id]);
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        this.setViewMode('forecast');
      },
    },
  },
};

</script>
